import { motion, useReducedMotion } from 'framer-motion';
import { resultsFor } from '../../data/method';
import { founder, salon } from '../../data/content';
import { shopLabels } from '../../data/shopLabels';
import type { Product } from '../../core/types/catalog';
import { ease } from '../../core/format/motion';
import { closingHeading } from '../../ui/sections';

/** Stagger per moment op de tijdlijn. */
const MOMENT_STEP_S = 0.06;

/** Eerlijke verwachting: wanneer zie je wat. Voorkomt afhaken na twee weken. */
export function ResultTimeline({
  product
}: {
  product: Product;
}) {
  const reduce = useReducedMotion();
  const moments = resultsFor(product.category);
  if (moments.length === 0) return null;
  return <section className="bg-blush py-20 lg:py-28" aria-labelledby="resultaat" data-id="element-8385" data-mp="1ynl2sehocv0m">
      <div className="mx-auto grid max-w-content gap-10 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-8386" data-mp="2cnvutkuq0fnd">
        <div className="lg:col-span-4" data-id="element-8387" data-mp="27ot0ovga3tu6">
          <h2 id="resultaat" className={`${closingHeading} text-ink`} data-id="element-8388" data-mp="27pua6vhnc89s">
            Wat je mag
            <span className="italic text-clay" data-id="element-8389" data-mp="1jtpffx0m9t9g"> verwachten</span>
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-muted" data-id="element-8390" data-mp="1or8sitlkvzzt">
            Je huid vernieuwt zich in ongeveer 28 dagen. Geef een product minimaal één volledige cyclus voordat je oordeelt.
          </p>
        </div>

        <div className="lg:col-span-8" data-id="element-8391" data-mp="1xti0pctdjha1">
          <ol className="relative grid gap-8 sm:grid-cols-3 sm:gap-6" data-id="element-8392" data-mp="1xqcd620e8ngf">
            <motion.span aria-hidden="true" initial={reduce ? false : {
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.3,
            ease
          }} className="absolute left-0 right-0 top-[5px] hidden h-px origin-left bg-clay/40 sm:block" data-id="element-8393" data-mp="22qqivdeivlba" />
            {moments.map((m, i) => <motion.li key={m.when} initial={reduce ? false : {
            opacity: 0,
            y: 8
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.3,
            delay: 0.1 + i * MOMENT_STEP_S,
            ease
          }} className="relative border-l border-line pl-5 sm:border-l-0 sm:pl-0" data-id="element-8394" data-mp="2lfyaejx7gsls" data-mpi={i}>
                <span aria-hidden="true" className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full border border-clay bg-blush sm:relative sm:left-0 sm:top-0 sm:block" data-id="element-8395" data-mp="106itxlmdn6qi" />
                <h3 className="type-name text-ink sm:mt-5" data-id="element-8396" data-mp="154aj47vn0er0">{m.when}</h3>
                <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-8397" data-mp="1563tny9dfj4a">{m.what}</p>
              </motion.li>)}
          </ol>
          <p className="mt-10 border-t border-ink/15 pt-5 text-[14px] leading-relaxed text-muted" data-id="element-8398" data-mp="1e5ig8mmf39ji">
            Iedere huid is anders. Merk je na zes weken niets?{' '}
            <a href={salon.whatsapp} target="_blank" rel="noreferrer" className="text-ink underline underline-offset-4 transition-colors duration-150 ease-soft hover:text-clay" data-id="element-8399" data-mp="3fvtysb1x58ij">
              App {founder.firstName}
              <span className="sr-only" data-id="element-8400" data-mp="20de2max2vnwm">{shopLabels.viaWhatsApp}</span>
            </a>{' '}
            — dan passen we je routine aan, of ruil je het product.
          </p>
        </div>
      </div>
    </section>;
}